module.exports = __webpack_public_path__ + "static/media/mail.0b563c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Person/components/Social/mail.svg
// module id = 107
// module chunks = 0